import { Injectable, Type } from '@angular/core';
import { InformationTemplateComponent } from './information-template/information-template.component';
import { BaseResultTemplateComponent } from "../base-result-template.component";
import { ResultTemplateComponent } from "./result-template/result-template.component";
import { BaseInformationTemplateComponent } from "../base-information-template.component";
import { BaseService } from "../base.service";

@Injectable({providedIn: 'root'})
export class MasterzulassungService extends BaseService {
  WORKFLOW_NAME = 'Process_interne_masterzulassung';
  static WORKFLOW_NAME = 'Process_interne_masterzulassung';

  getInformationTemplate(): Type<BaseInformationTemplateComponent> {
    return InformationTemplateComponent;
  }

  getResultTemplate(): Type<BaseResultTemplateComponent> {
    return ResultTemplateComponent;
  }
}
